
import React from 'react';
import { Expense } from '@/types/expense';
import ExpenseTableRow from './ExpenseTableRow';

interface ExpenseTableBodyProps {
  expenses: Expense[];
  currentUserId?: string;
  showActions: boolean;
  formatCurrency: (amount: number, currency: string) => string;
  formatDate: (dateString: string) => string;
}

const ExpenseTableBody: React.FC<ExpenseTableBodyProps> = ({ 
  expenses, 
  currentUserId, 
  showActions,
  formatCurrency,
  formatDate
}) => {
  return (
    <tbody className="divide-y divide-gray-200">
      {expenses.map((expense) => (
        <ExpenseTableRow
          key={expense.id}
          expense={expense}
          currentUserId={currentUserId}
          showActions={showActions}
          formatCurrency={formatCurrency}
          formatDate={formatDate}
        />
      ))}
    </tbody>
  );
};

export default ExpenseTableBody;
